import type { DayHeaderContentArg } from "@fullcalendar/core";
import { Typography } from "@mui/material";
import styled from "styled-components";

export const renderDayHeaderContent = (args: DayHeaderContentArg) => {
  const { date, isToday, text } = args;

  return (
    <DayHeaderContent $isToday={isToday}>
      <StyledTypography $isToday={isToday} variant="label">
        {text}
      </StyledTypography>
      <StyledTypography $isToday={isToday} variant="subtitle2">
        {date.getDate()}
      </StyledTypography>
    </DayHeaderContent>
  );
};

const StyledTypography = styled(Typography)<{ $isToday: boolean }>`
  color: ${({ $isToday, theme }) => ($isToday ? theme.colors.redesign.b100 : theme.colors.redesign.db100)} !important;
  text-transform: capitalize;
`;

const DayHeaderContent = styled.div<{ $isToday: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border-radius: 12px;
  padding: 8px;
  background: ${({ $isToday, theme }) => ($isToday ? theme.colors.redesign.b10 : theme.colors.white)};
  border: 1px solid ${({ $isToday, theme }) => ($isToday ? theme.colors.redesign.b100 : theme.colors.redesign.db20)};
  pointer-events: none;
  min-width: 50px;
`;
